
import { defineComponent, reactive, ref, onMounted } from 'vue';
import { useToast } from "vue-toastification";
import { useRouter } from 'vue-router'
import OrderingInfo from '@/components/OrderingInfo.vue';
import db from '../db'

export default defineComponent({
  name: 'Search',
  props: ['refKey'],
  components: {OrderingInfo},
  setup(props){

    const router = useRouter()
    const toast = useToast()
    const inputRefKey = ref<string>()
    const view = ref<number>(2)
    
    const userOrdering = reactive({
      data:{
        username:'',
        ordering: '',
        ps: ''
      }
    })
    
    const order = reactive({
      data: {
        name: 'None',
        image: '',
        options: '',
      }
    })


    const searchOrder = (): void => {
      const key = inputRefKey.value?.trim()
      router.push('/search/' + key)
      db.database().ref('orders/' + key).on('value', snapshot =>{
        if(!key || key === ''){
          toast.warning('請輸入訂單編號')
          return
        }
        
        if (!snapshot.exists()){
          toast.error('查無此訂單')
          return
        }
        const orderData = snapshot.val()
        order.data = orderData
      })
    }

    const addToOrderings = (index: number): void=>{
      const selectOption = order.data.options[index]
      const orderings = userOrdering.data.ordering
      if (orderings.includes(selectOption))return
      userOrdering.data.ordering += selectOption + '、'
    }

    const updateOrder = (): void => {
      if(order.data.name === 'None') {
        toast.error('訂單不存在')
        return
      }

      if(userOrdering.data.ordering.trim() === '') {
        toast.error('訂購品項請勿留空')
        return
      }
      const orderRef = db.database().ref('orders/' + inputRefKey.value)
      orderRef.get().then(snapshot=>{
        if (snapshot.val().orderings) {
          const data = snapshot.val().orderings
          data.push(userOrdering.data)
          orderRef.update({orderings: data})
        }
        else{
          const data = [userOrdering.data]
          orderRef.update({orderings: data})
        }

        toast.success('已新增訂購!')

        userOrdering.data.username = ''
        userOrdering.data.ordering = ''
        userOrdering.data.ps = ''

        view.value = 2
      })
    }


    onMounted(()=>{
      if(inputRefKey.value === '') return
      inputRefKey.value = props.refKey
      if(props.refKey) searchOrder()
    })

    
    return{
      view,
      inputRefKey,
      searchOrder,
      order,
      updateOrder,
      userOrdering,
      addToOrderings,

    }
  }

});
